// local hook used in the context of reports page
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useGroupBy } from '@/hooks';
import { PointOfInterestsFragment } from '@/__generated__/graphql';
import { GroupByResult, MappedReportPointOfInterests } from '@/types';

export const usePointOfInterestDetails = (): {
  assemblies: { id: string; tagName: string }[];
  groupPoiByEquipmentWithNumbers: GroupByResult<MappedReportPointOfInterests>;
} => {
  const selectedReport = useAtomValue(state.selectedReport);
  let count = 1;
  const pois: MappedReportPointOfInterests[] | undefined = useMemo(() => {
    const pointOfInterests: PointOfInterestsFragment[] | undefined | null =
      selectedReport?.pointOfInterests;

    return pointOfInterests?.map((p) => {
      return {
        ...p,
        tagName: p.assembly.tagName,
        assemblyId: p.assembly.id,
        pointNumber: 0,
        centerPoint3d: p.centerPoint3d,
      };
    });
  }, [selectedReport]);

  const groupPoiByEquipment: GroupByResult<MappedReportPointOfInterests> = useGroupBy(
    pois,
    'tagName'
  );
  const groupPoiByEquipmentWithNumbers: GroupByResult<MappedReportPointOfInterests> = {};
  Object.keys(groupPoiByEquipment).forEach((key) => {
    groupPoiByEquipmentWithNumbers[key] = groupPoiByEquipment[key].map((p) => {
      return {
        ...p,
        tagName: p.assembly.tagName,
        assemblyId: p.assembly.id,
        pointNumber: count++,
      };
    });
  });

  // get assemblies in form of id and tagName
  const assemblies = useMemo(() => {
    if (!pois) return [];

    const uniqueAssemblies = Array.from(
      new Map(
        pois.map((p) => [p.assembly.id, { id: p.assembly.id, tagName: p.assembly.tagName }])
      ).values()
    );

    return uniqueAssemblies;
  }, [pois]);

  return { assemblies, groupPoiByEquipmentWithNumbers };
};
